import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { verifyLead } from "../services/api";

function Field({ label, value }) {
  return (
    <div className="verify-field">
      <span className="verify-label">{label}</span>
      <span className="verify-value">{value}</span>
    </div>
  );
}

function formatDate(iso) {
  return new Date(iso).toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export default function VerifyPage() {
  const { token } = useParams();
  const [lead, setLead]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState("");

  useEffect(() => {
    verifyLead(token)
      .then(setLead)
      .catch(() => setError("Invalid or expired QR code."))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="verify-wrapper">
      <div className="verify-card">
        <a href="/">
          <img src="/logo.jpeg" alt="Uni Global" className="verify-logo" />
        </a>

        {loading && <p className="verify-status">Verifying…</p>}

        {error && (
          <div className="verify-invalid">
            <div className="verify-badge verify-badge--invalid">✗ Invalid QR Code</div>
            <p>{error}</p>
          </div>
        )}

        {lead && (
          <>
            <div className="verify-badge verify-badge--valid">✓ Valid Registration</div>

            <div className="verify-fields">
              <Field label="Full Name"      value={lead.full_name} />
              <Field label="Mobile"         value={lead.mobile_number} />
              <Field label="Email"          value={lead.email} />
              <Field label="Study Country"  value={lead.study_country} />
              <Field label="Loan Amount"    value={lead.loan_amount} />
              <Field label="Submitted At"   value={formatDate(lead.created_at)} />
              <Field label="WhatsApp Sent"  value={lead.whatsapp_sent ? "Yes ✅" : "No"} />
            </div>

            <div className="verify-id">
              Enquiry ID: <strong>{lead.qr_token.slice(0, 8).toUpperCase()}</strong>
            </div>
          </>
        )}

        <div className="verify-footer">
          <p>Uni Global Education Consultancy Pvt. Ltd.</p>
          <p>+91 742 999 2222 | uniglobaleducon.com</p>
        </div>
      </div>
    </div>
  );
}
